import React, { useCallback, useEffect, useState } from 'react'

import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { withRouteData, withRouter } from 'react-static'

import NavBar from './NavBar'
import { serverURL } from './config'
import { setLanguage, setUser } from './redux/actionCreators'

function Header({ header, history }) {
  const [isLoading, setIsLoading] = useState(false)
  const [isLoggingOut, setIsLoggingOut] = useState(false)

  const headerStory = header || { content: { Links: [] } }

  const dispatch = useDispatch()

  const user = useSelector(state => state.user)
  const language = useSelector(state => state.lng)

  const requestUser = useCallback(async () => {
    try {
      setIsLoading(true)

      const userResponse = await axios.get(`${serverURL}/user`)
      if (userResponse.data.user) dispatch(setUser(userResponse.data.user))
    } catch (err) {
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }, [dispatch])

  const handleLanguageChange = useCallback(
    language => {
      const languageRegex = /\/en|\/es/g
      const urlWithReplacedLanguage = history.location.pathname.replace(
        languageRegex,
        '',
      )
      const urlHash = history.location.hash

      dispatch(setLanguage(language))
      history.push(`/${language}${urlWithReplacedLanguage}${urlHash}`)
    },
    [dispatch, history],
  )

  useEffect(() => {
    requestUser()
  }, [requestUser])

  useEffect(() => {
    const isSpanish = history.location.pathname.includes('/es')
    const platformLanguage = isSpanish ? 'es' : 'en'

    handleLanguageChange(platformLanguage)
  }, [history.location.pathname, handleLanguageChange])

  async function logout() {
    setIsLoggingOut(true)

    try {
      await axios.post(`${serverURL}/logout`)
      window.location.reload()
    } catch (error) {
      console.error(error)
    }
    setIsLoggingOut(false)
  }

  return (
    <div style={{ top: 0, position: 'sticky', zIndex: 10 }}>
      {isLoading && (
        <div className='relative flex h-22'>
          <div className='spinner' />
        </div>
      )}

      {!isLoading && (
        <div>
          <NavBar
            // @ts-expect-error - NavBar has no typed props
            user={user}
            lng={language}
            logOut={() => logout()}
            headerStory={headerStory}
            loggingOut={isLoggingOut}
            handleLanguageChange={lng => handleLanguageChange(lng)}
          />
        </div>
      )}
    </div>
  )
}

export default withRouter(withRouteData(Header))



// WEBPACK FOOTER //
// /opt/build/repo/src/Header.jsx